<template>
  <div class="content-box bgff">
    <div class="personal_body_title bgf5">
      <div class="colorff bg02 text_center font20">{{content.programName}}</div>
    </div>
    <div class="information_title">
      <div class="bg02 color02"></div>
      <div class="font20">{{content.title}}</div>
    </div>
    <div>
      <div class="help_content ql-editor" v-html="content.content"></div>
    </div>
    <div class="tc-70"></div>
  </div>
</template>

<script>
// import apiHelp from '@/api/apiHelp'
export default {
  name: 'Content',
  data () {
    return {
      value1: true,
      value2: true
    }
  },
  watch: {
    handler () {
      //
    }
  },
  props: ['content'],
  // 方法
  methods: {
    async getData () {
      // let id = this.$route.query.id
      // let res = await apiHelp.getContentDetails(id)
    }
  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang="scss" rel="stylesheet/scss" >
.content-box{
  .information_title{
    /* width: 960px; */
    margin: 0 0 0 20px;
    text-indent: 20px;
    /* text-indent: 34px; */
    height: 60px;
    line-height: 60px;
    position: relative;
    >div:nth-child(1){
      width: 4px;
      height: 20px;
      position: absolute;
      left: 0;
      top: 20px;
    }
  }
  .bg02 {
    background: #0286df;
  }
  .bgf5 {
    background: #f5f5f5;
  }

  .colorff {
    color: #fff;
  }

  .personal_body_title{
    width: 100%;
    height: 45px;
    border-bottom: 1px solid #0286df;
    div{
      width: 160px;
      height: 45px;
      line-height: 45px;
    }
  }
  .help_content{
    padding: 0 35px;
  }
  .text_center {
    text-align: center;
  }
}
</style>
